import React from 'react';
import { Grid } from '@mui/material';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';

const editorRenderer = (getControl) => (
  <Grid container spacing={2}>
    <Grid item sm={6}>
      {getControl('locality')}
    </Grid>
    <Grid item sm={6}>
      {getControl('name')}
    </Grid>
  </Grid>
);

export default getBaseEditor(editorRenderer, '/api/catalog/areas/', CommandPanels.catCommandPanel);
